import request from '@/utils/request'

let CustomizationApi = {
    /*栏目管理*/
    fodderList(data, errorback) {
        return request._post('/shop/customization.Fodder/index', data, errorback);
    },
    /*栏目添加*/
    fodderAdd(data, errorback) {
        return request._post('/shop/customization.Fodder/add', data, errorback);
    },
    /*栏目删除*/
    fodderDel(data, errorback) {
        return request._post('/shop/customization.Fodder/delete', data, errorback);
    },
    /*栏目修改*/
    fodderEdit(data, errorback) {
        return request._post('/shop/customization.Fodder/edit', data, errorback);
    },
    /*栏目修改*/
    getCatList(data, errorback) {
        return request._post('/shop/customization.Category/getList', data, errorback);
    },
    /*分类管理*/
    catList(data, errorback) {
        return request._post('/shop/customization.Category/index', data, errorback);
    },
    /*分类添加*/
    catAdd(data, errorback) {
        return request._post('/shop/customization.Category/add', data, errorback);
    },
    /*分类删除*/
    catDel(data, errorback) {
        return request._post('/shop/customization.Category/delete', data, errorback);
    },
    /*分类修改*/
    catEdit(data, errorback) {
        return request._post('/shop/customization.Category/edit', data, errorback);
    },
    /*得到分类图片*/
    cateImage(data, errorback) {
        return request._post('/shop/customization.Category/image', data, errorback);
    },
    /*获取设置*/
    getSetting(data, errorback) {
      return request._post('/shop/customization.Setting/getSetting', data, errorback);
    },
    /*保存设置*/
    editSetting(data, errorback) {
      return request._post('/shop/customization.Setting/editSetting', data, errorback);
    },
    /*订单列表*/
    orderlist(data, errorback) {
        return request._post('/shop/customization.order/index', data, errorback);
    },
    /*订单详情*/
    orderdetail(data, errorback) {
        return request._post('/shop/customization.order/detail', data, errorback);
    },
    /*修改快递*/
    updateExpress(data, errorback) {
        return request._post('/shop/customization.order/updateExpress', data, errorback);
    },
    /*修改收件地址*/
    updateAddress(data, errorback) {
        return request._post('/shop/customization.order/updateAddress', data, errorback);
    },
    /*去发货*/
    delivery(data, errorback) {
        return request._post('/shop/customization.order/delivery', data, errorback);
    },
    /*确认收货*/
    orderReceipt(data, errorback) {
        return request._post('/shop/customization.order/receipt', data, errorback);
    },
    /*确认审核*/
    confirm(data, errorback) {
        return request._post('/shop/customization.order/confirmCancel', data, errorback);
    },
    /*物流轨迹*/
    getExpressTrack(data, errorback) {
        return request._post('/shop/customization.order/track', data, errorback);
    },
    /*核销*/
    extract(data, errorback) {
        return request._post('/shop/customization.order/extract', data, errorback);
    },
}

export default CustomizationApi;



// WEBPACK FOOTER //
// ./src/api/customization.js